import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const security: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  '&.security__notglobal': {
    marginTop: spacing(7),
    gap: spacing(4),
  },
  '.security__menu': {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(4),
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    backgroundColor: 'palette.background.paper',
    borderBottom: '1px solid',
    borderBottomColor: 'palette.border.article',
    zIndex: 2,
    pt: '16px',
    pb: '16px',
    overflow: 'hidden',
  },
  '.security__menu__search': {
    flexBasis: '100%',
    '.deletableInput': {
      display: 'inline-flex',
      flexDirection: 'row',
      height: '44px',
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      input: {
        height: '44px',
      },
      '.deletableInput__deleteButton': {
        position: 'absolute',
        right: '6px',
        alignSelf: 'center',
      },
    },
  },
  '.security__menu__buttons': {
    height: '44px',
    flexShrink: '0',
    button: {
      height: '100%',
    },
  },
  '.security__list': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(7),
  },
  '.security__environments': {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderColor: 'palette.border.article',
    p: spacing(7),
    pt: spacing(0),
    gap: spacing(4),
  },
  '.security__environments__first': {
    borderTop: 0,
  },
  '.security__environments__disabled': {
    backgroundColor: 'palette.background.default',
  },
  '.security__environments__header': {
    backgroundColor: 'palette.background.paper',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    gap: responsive({ 0: 4, 2: 0 }),
    alignItems: 'center',
    position: 'sticky',
    top: '74px',
    borderBottom: '1px solid',
    borderBottomColor: 'palette.border.section',
    zIndex: 1,
    pt: '16px',
    pb: '16px',
  },
  '.security__environments__header__single': {
    backgroundColor: 'palette.background.paper',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    gap: responsive({ 0: 4, 2: 0 }),
    alignItems: 'center',
    borderBottom: '1px solid',
    borderBottomColor: 'palette.border.section',
    zIndex: 1,
    pt: '16px',
    pb: '16px',
  },
  '.security__environments__header__content': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '.showAllBtn': {
      variant: 'buttons.icon-outline',
    },
  },
  '.security__environments__header__title': {
    overflow: 'hidden',
    textOverflow: responsive({ 0: 'ellipsis', 3: 'none' }),
    whiteSpace: responsive({ 0: 'nowrap', 3: 'unset' }),
    width: responsive({ 0: '170px', 2: 'auto' }),
  },
  '.security__environments__header__title__disabled': {
    color: 'palette.text.disabled',
  },
  '.security__environments__header__buttons': {
    display: responsive({ 0: 'contents', 1: 'flex' }),
    alignItems: 'center',
    flexDirection: 'row',
    gap: spacing(4),
    '.deleteEnvBtn': {
      display: 'flex',
      padding: spacing(1),
      width: '32px',
      height: '32px',
      color: 'palette.text.primary',
      backgroundColor: 'transparent',
      '&:disabled': {
        opacity: 0,
      },
      svg: {
        width: '28px',
        height: '28px',
      },
    },
  },
  '.security__environments__header__disabled': {
    backgroundColor: 'palette.background.default',
  },
  '.security__environments__section': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: spacing(3),
    justifyContent: 'space-between',
    h4: {
      m: spacing(0),
    },
  },
  '.security__environments__wrapper': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: spacing(3),
    fontWeight: 'bold',
    width: '100%',
    height: '100%',
  },
  '.security__environments__message': {
    fontWeight: 'normal',
    fontStyle: 'italic',
  },
  '.security__environments__boxlist': {
    width: '100%',
    height: '100%',
    alignItems: 'start',
    alignContent: 'start',
    maxHeight: responsive({ 0: '50vh', 3: '27vh' }),
    overflow: 'auto',
    display: 'grid',
    gap: spacing(3),
    pr: spacing(3),
    fontWeight: 'normal',
    gridTemplateColumns: responsive({
      0: 'repeat(1, 1fr)',
      3: 'repeat(2, 1fr)',
      5: 'repeat(3, 1fr)',
      6: 'repeat(4, 1fr)',
    }),
    '.labelBox, .infoBox': {
      backgroundColor: 'palette.background.paper',
      span: {
        display: 'block',
        textAlign: 'left',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '.closeButton, .iconButton': (theme) => ({
        width: '32px',
        height: '32px',
        ...theme.palette.getStatesFromPath('buttons.outlineDanger', {
          states: {
            active: false,
            checked: false,
            default: false,
            disabled: false,
            focus: false,
            path: false,
            readonly: false,
            selected: false,
          },
        }),
        '&:hover': {
          ...theme.palette.getStatesFromPath('buttons.icon', {
            states: {
              active: false,
              checked: false,
              default: false,
              disabled: false,
              focus: false,
              hover: false,
              readonly: false,
              selected: false,
            },
          }),
        },
        '&:disabled': {
          opacity: 0.25,
        },
      }),
    },
  },
  '.security__environments__boxlist__fixed': {
    minHeight: responsive({ 0: '50vh', 3: '27vh' }),
    border: '1px solid',
    borderColor: 'palette.border.article',
    p: spacing(3),
  },
  '.security__environments__properties__content': {
    width: '100%',
    maxHeight: responsive({ 0: '35vh', 3: '20vh' }),
    overflow: 'auto',
    display: 'grid',
    gap: spacing(3),
    pr: spacing(3),
    gridTemplateColumns: responsive({
      0: 'repeat(1, 1fr)',
      3: 'repeat(2, 1fr)',
      5: 'repeat(3, 1fr)',
      6: 'repeat(4, 1fr)',
    }),
    '.security__environments__properties__content__item': {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      gridColumnStart: 1,
      div: {
        width: '100%',
      },
    },
  },

  '.security__environments__properties': {},
  '.security__environments__pools': {},
  '.security__environments__profiles': {},
  '.security__environments__orgroles': {},
};

export default security;
